import React from 'react';
import { PictoProps } from './index';

export const CaretDown = (props: PictoProps) => (
  <svg
    width={props.width || '15'}
    height={props.height || '8'}
    viewBox="0 0 15 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.44434 1L7.44434 7L13.4443 1"
      stroke="#004653"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
